// API Configuration for different environments

const config = {
  development: {
    API_URL: 'http://localhost:8080',
  },
  production: {
    API_URL: '', // Empty string means same origin (frontend and backend on same server)
  }
};

const environment = process.env.NODE_ENV || 'development';

export const API_URL = config[environment].API_URL;

const configExport = {
  API_URL,
  environment,
};

export default configExport;
